import { render, staticRenderFns } from "./transferSlipEnter.vue?vue&type=template&id=4047c144&scoped=true"
import script from "./transferSlipEnter.vue?vue&type=script&lang=js"
export * from "./transferSlipEnter.vue?vue&type=script&lang=js"
import style0 from "./transferSlipEnter.vue?vue&type=style&index=0&id=4047c144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047c144",
  null
  
)

export default component.exports